<template>
    <div class="loginWrap" :style="wrapStyle">
        <p class="title">
            智慧消防物联平台
        </p>
        <div class="loginDiv">
            <div class="imgWrap">
                <img :src="logo" alt="">
            </div>
            <p class="loginP">
                监控中心
            </p>
            <div class="inputWrap">
                <p>
                    <span>
                    登录名：
                    </span>
                    <input type="text" ref="account">
                </p>
                <p>
                    <span>
                    密码：
                    </span>
                    <input type="password" ref="password">
                </p>
                <p class="loginBtn" @click="loginFn">
                    登录
                </p>
            </div>
            <div class="retrieve"><span class="m-r-20" @click="type = 1;retrieveState=true;showTable=false">忘记登录名</span><span @click="type = 2;retrieveState=true;showTable=false">忘记密码</span></div>
        </div>
        <div class="copyRight">
            Copyright Since 2017 All Rights Reserved. 版权所有 河南力安测控科技有限公司 | 安易云
            <!-- <p>备案号：滇ICP备2025050540号</p> -->
        </div>
        <Modal
                v-model="retrieveState"
                :title="type == 1 ? '忘记登录名' : '忘记密码'"
                :mask-closable="false"
                @on-cancel="closemodal" width="660"
        >
            <div style="width:90%;margin:auto" class="passbox" v-show="!showTable">
                <Form ref="retrievePass" :model="passwordData" :rules="rules" :label-width="80">
                    <FormItem label="登录名" prop="loginName" v-if="type == 2">
                        <Input v-model="passwordData.loginName" type="text" placeholder="请输入登录名"></Input>
                    </FormItem>
                    </FormItem>
                    <FormItem label="手机号" prop="phone">
                        <Row>
                            <i-col span="17">
                            <Input v-model="passwordData.phone" placeholder="请输入手机号" type="tel"></Input>
                            </i-col>
                            <i-col span="7">
                                <Button @click="codeText == '获取验证码' ? getCode() : null" style="float:right" :style="{cursor: codeText == '获取验证码' ? 'pointer' : 'default'}">{{codeText}}</Button>
                            </i-col>
                        </Row>
                    </FormItem>
                    <FormItem label="验证码" prop="code">
                        <Input v-model="passwordData.code" type="text" placeholder="请输入验证码"></Input>
                    </FormItem>
                    <FormItem label="新密码" prop="password" class="modify" v-if="type == 2">
                        <Input v-model="passwordData.password"  type="text" placeholder="请输入新密码" class="input"></Input>
                        <Input v-model="passwordData.password"  type="password" readonly disabled placeholder="请输入新密码"></Input>
                    </FormItem>
                    <FormItem label="确认密码" prop="passwordAgain" class="modify" v-if="type == 2">
                        <Input v-model="passwordData.passwordAgain" type="text" placeholder="确认密码" class="input"></Input>
                        <Input v-model="passwordData.passwordAgain" type="password" readonly disabled placeholder="确认密码"></Input>
                    </FormItem>

                </Form>
            </div>
            <private-table class="p_table" v-show="showTable" pageHide="true" :columnsList="columnsLabel" :dataTable="dataTable" :height="285"></private-table>
            <div slot="footer" class="primary_button">
                <Button v-if="showTable" @click="closemodal">关闭</Button>
                <Button v-else @click="confirmModification" type="primary">确定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    import Vue from 'vue'
    Vue.prototype.$mqtt = null;
    import logo from '@/assets/img/login-logo.png'
    import bg from '@/assets/img/login-bg.jpg'

    // 随机字符串
    import getRandVal from '@/assets/js/index'
    // 加密
    import Base64 from '@/assets/js/base64.js'
    import md5 from 'js-md5'
    import CryptoJS from '@/assets/js/core.js'
    import axios from 'axios'
    var SHA256 = require('../assets/js/sha256.js');
    import {login, verificationCode, verify} from '@/assets/js/url.js';
    import privateTable from '../components/wit-electric-monitor/private-table';


    export default {
        name: "",
        data() {
            const validateLoginName = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入登录名'));
                } else if (!/^[0-9a-zA-Z]{5,20}$/.test(value)) {
                    callback('登录名长度应在5-20个字符内');
                } else {
                    callback();
                }
            };
            const validatePhone = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入手机号'));
                } else if (!/^1[23456789]\d{9}$/.test(value)) {
                    callback('手机号格式不正确');
                } else {
                    callback();
                }
            };
            const validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入新密码'));
                } else if(!this.hasConsecutiveCharacters(value)){
                    callback("密码强度较弱，8位以上不连续大小写字母，数字特殊字符(!@#$%^&*)");
                }else {
                    callback();
                }
            };
            const validatePassAgain = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请确认密码'));
                } else if (value !== this.passwordData.password) {
                    callback('两次输入密码不一致');
                } else {
                    callback();
                }
            };
            return {
                logo: logo,
                wrapStyle: {
                    backgroundImage: 'url(' + bg + ')'
                },
                type: 1,//1：忘记登录名   2：忘记密码
                showTable:false,//是否展示登录名表格
                retrieveState: false,
                codeText:'获取验证码',
                timer: null,
                passwordData:{
                    loginName:'',
                    phone:'',
                    code:'',
                    password:'',
                    passwordAgain:'',
                },
                rules:{
                    loginName:[
                        { required: true, validator: validateLoginName, trigger: 'blur' }
                    ],
                    phone:[
                        { required: true, validator: validatePhone, trigger: 'blur' }
                    ],
                    code:[
                        { required: true, message: '请输入验证码', trigger: 'blur' }
                    ],
                    password:[
                        { required: true, validator: validatePass, trigger: 'blur' }
                    ],
                    passwordAgain:[
                        { required: true, validator: validatePassAgain, trigger: 'blur' }
                    ],
                },
                columnsLabel:[
                    {
                        title: '所属单位',
                        key: 'orgName'
                    },
                    {
                        title: '登录名',
                        key: 'loginName'
                    }
                ],
                dataTable:{},
                list:[],
                page: {
                    totalCount: 0,
                    pageSize: 10,
                    currentPage: 1
                },
                token: ''
            }
        },
        components: {
            privateTable
        },
        created() {
            var that = this;
            if (window.localStorage.getItem('lhLoginName') && window.localStorage.getItem('lhPwdHash')) { //值守平台联合登录
                that.getDataFn(window.localStorage.getItem('lhLoginName'), window.localStorage.getItem('lhPwdHash'));
            }
            document.onkeyup = function (e) {
                e = e || event;
                var code = e.charCode || e.keyCode;
                if (code == 13) {
                    //此处编写用户敲回车后的代码
                    that.loginFn();
                }
            }
        },
        mounted() {
            window.localStorage.removeItem('loginData');
            window.localStorage.removeItem('hashValue');
            window.localStorage.removeItem('setAzindex');
        },
        computed: {},
        methods: {
            loginFn() {
                if (this.$refs.account.value == "") {
                    alert('登录名不能为空！');
                } else if (this.$refs.password.value == "") {
                    alert('密码不能为空！');
                } else {
                    if(!/^[0-9a-zA-Z]{5,20}$/.test(this.$refs.account.value)) {
                        alert('登录名格式不正确！');
                    }else{
                        // 这里需要个登录接口,调取接口，返回正确，跳转到index页面，错误，弹窗提示账户密码错误
                        this.getDataFn(this.$refs.account.value, CryptoJS.SHA256(this.$refs.password.value));
                    }
                }
            },
            hasConsecutiveCharacters(password) {
         if (!/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/.test(password)) {
           return false;
          }
          if (/(.)\1{2,}/.test(password)) {
              return false;
          }
          // 检查连续3个及以上递增或递减的数字
          if (/012|123|234|345|456|567|678|789|987|876|765|654|543|432|321|210/i.test(password)) {
              return false;
          }
          if (/abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz|zyx|yxw|xwv|wvu|vut|uts|tsr|srq|rqp|qpo|pon|onm|nml|mlk|lkj|kji|jih|ihg|hgf|gfe|fed|edc|dcb|cba/i.test(password)) {
              return false;
          }
          return true;
    },
            getPwdHash(pwd, data) {  //
                var sha = md5(pwd + data);
                var base = new Base64();
                var pwdHashStr = base.encode(sha);
                return pwdHashStr;
            },
             //获取mqtt地址
            getMqttUrl() {
                return new Promise((resolve, reject) => {
                    var data = {
                        type: "get",
                        url: "/mcbw/file/template_static",
                        obj: {
                            fileKey:"mqtt_url_ws"
                        },
                    };
                    this.$Axios(data)
                    .then((res) => {
                        if (res.data.success) {
                            window.localStorage.setItem('mqttapi', res.data.data);
                            this.$store.commit('setmqttapi', res.data.data);
                            let MQTTWrapper = require("@/assets/js/mqttHandler.js");
                            Vue.prototype.$mqtt = new MQTTWrapper.default();
                            resolve(res.data)
                        }
                    })
                });
            },
            getDataFn(loginName, passWord) {
                let _that =  this;
                //获取随机数
                var randVal = getRandVal();
                var data = {
                    type: 'post',
                    url: login,
                    obj: {
                        user: loginName,
                        password: passWord
                    }
                }
                this.$Axios(data).then((res) => {
                    console.log(res.data);
                    console.log(randVal);
                    if (res.data.code == 200) {   //登录成功跳转到首页
                        // window.localStorage.setItem('userFirstInto',true);
                        window.localStorage.setItem('loginData', JSON.stringify(res.data.data.depInfo)); //本地保存登录信息
                        window.localStorage.setItem('hashValue', passWord);

                        window.localStorage.setItem('setAzindex', 'true');

                        window.localStorage.removeItem('lhLoginName');
                        window.localStorage.removeItem('lhPwdHash');
                        this.getMqttUrl().then((res) => {
                            setTimeout(() => {
                                _that.$router.replace({name: 'indexPage'});
                            },1500)
                        })
                        
                    } else {
                        alert('登录名或密码错误，请重新输入！');
                        window.localStorage.removeItem('loginData');//清除本地存储登录信息
                    }
                }).catch((res) => {
                    console.log(res);
                });
            },
            getCode(){ //获取验证码
                let self = this;
                if(this.passwordData.phone && /^1[23456789]\d{9}$/.test(this.passwordData.phone)){
                    this.codeText = '发送中...'
                    axios.get(verificationCode, {
                        params:{
                            params: {
                                phoneNum:this.passwordData.phone
                            }
                        }
                    }).then(function (res) {
                        console.log(res);
                        if (res.data.success) {
                            self.codeText = '已发送'
                            var num = 60
                            self.timer = setInterval(()=>{
                                self.codeText = num + 's'
                                num --
                                if(num < 0){
                                    clearInterval(self.timer)
                                    self.codeText = '获取验证码'
                                }
                            },1000)
                        }else{
                            self.codeText = '获取验证码'
                            alert(res.data.message)
                        }
                    });
                }else{
                    alert('请输入正确的手机号')
                }
            },
            closemodal(){  //关闭弹窗 清空计时器
                clearInterval(this.timer)
                this.codeText = '获取验证码'
                this.showTable = false
                this.retrieveState = false
                this.$refs.retrievePass.resetFields()
            },
            confirmModification(){ //校验验证码
                let self = this;
                this.$refs.retrievePass.validate((valid) =>{
                    if(valid){
                        axios.post(verificationCode, {
                            commitData: {
                                phoneNum: this.passwordData.phone,
                                verificationCode: this.passwordData.code,
                            }
                        }).then(function (res) {
                            if (res.data.success) {
                                self.token = res.data.data.token;
                                self.changePassword();
                            }else{
                                alert(res.data.message)
                            }
                        }).catch(function (error) {
                            alert(error);
                        });
                    }
                })
            },
            changePassword() {
                let commitData;
                let self = this;
                if(this.type == 1){
                    commitData = {
                        verifyType: 'lgn',
                        phoneNum: this.passwordData.phone,
                        token: self.token
                    };
                }else{
                    commitData = { //修改密码
                        verifyType: 'psw',
                        loginName: this.passwordData.loginName,
                        phoneNum: this.passwordData.phone,
                        password: CryptoJS.SHA256(this.passwordData.password).toString(),
                        token: self.token
                    };
                }
                axios.put(verify, {
                    commitData
                }).then(function (res) {
                    if(res.data.success){
                        if(self.type == 1){//表格
                            self.$nextTick(() => {
                                self.showTable = true
                                self.list = res.data.data;
                                self.page.totalCount = res.data.data.totalCount;
                                self.dataTable = {
                                    list: self.list,
                                    page: self.page,
                                }
                            })
                        }else{//修改密码
                            alert('密码修改成功！')
                            self.closemodal()
                        }
                    }else{
                        alert(res.data.message)
                    }
                }).catch(function (error) {
                    alert(error);
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    .loginWrap {
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        .title {
            font-size: 36px;
            border-bottom: 1px solid rgba(255, 255, 255, .2);
            color: #fff;
            font-weight: 600;
            text-indent: 72px;
            height: 90px;
            line-height: 90px;
        }
        .loginDiv {
            width: 360px;
            height: 380px;
            background: rgba(255, 255, 255, 0.8);
            position: absolute;
            top: 20%;
            right: 10%;
            box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.1);
            padding: 20px;
            border-radius: 5px;
            .imgWrap {
                width: 60px;
                height: 60px;
                background: #5b8cff;
                border-radius: 50%;
                box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.1);
                text-align: center;
                margin: -50px auto 0;
                img {
                    width: 40px;
                    display: inline-block;
                    margin-top: 14px;
                }
            }
            .loginP {
                text-align: center;
                color: #535b6c;
                font-weight: normal;
                font-size: 24px;
                margin-top: 30px;
            }
            .inputWrap {
                margin-top: 40px;
                span {
                    font-size: 14px;
                    display: inline-block;
                    width: 60px;
                    text-align: right;
                    color: #626c81;
                    line-height: 60px;
                    font-weight: normal;
                }
                input {
                    border: 1px solid #cadaff;
                    background: #f0f3fa;
                    padding-left: 5px;
                    color: #000000;
                    height: 36px;
                    line-height: 36px;
                    width: 244px;
                }
                .loginBtn {
                    border: 0;
                    height: 44px;
                    text-align: center;
                    line-height: 44px;
                    width: 312px;
                    margin: 20px auto;
                    background: #5b8cff;
                    font-size: 16px;
                    color: #FFFFFF;
                    border-radius: 5px;
                    display: block;
                    cursor: pointer;
                }
            }

            .retrieve{
                cursor: pointer;
                color: #9fa2a8;
                font-size: 12px;
                text-align: right;
                margin-top: -5px;
            }
        }
        .copyRight {
            color: #FFFFFF;
            font-size: 14px;
            position: fixed;
            bottom: 0;
            width: 100%;
            line-height: 24px;
            padding-left: 20px;
            text-align: center;
        }
        .passbox .ivu-btn:focus{
            box-shadow: none !important;
        }
    }
    .modify{
        position: relative;
        .input{
            position: absolute;
            z-index: 10;
            opacity: 0;
        }
    }
    /deep/ .passbox .ivu-input {
        background: #f5f8ff !important;
        padding-left: 5px !important;
        color: #555555;
        border: 1px solid #dcdee2;
    }

    /deep/ .primary_button .ivu-btn-primary {
        background: #5b8cff !important;
        color: #FFFFFF !important;
    }

    /deep/ .p_table table th, /deep/ .p_table table td{
        background: #f8f8f9 !important;
        color: #515a6e !important;
    }
</style>


// WEBPACK FOOTER //
// src/pages/login.vue